import React, { useState, useEffect, useCallback, useRef } from "react";
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoading } from "../../../../context/LoadingContext";
import { jwtDecode } from "jwt-decode";
import config from "../../../../aws-exports";
import { getParameterFromManager } from "../../../../services/Utils";
import "../../../../styles/general.css";
import "../../../../styles/amtpl.css";
import SidebarCommon from "../../../../pages/Requirement/components/layout/AMTPLSidebar";
import Header from "../../../../pages/Requirement/components/layout/Header";
import DataTable from "../../../../pages/Requirement/components/common/ReusableTable";
import SearchFilter from "../../../../pages/Requirement/components/common/SearchFilter";
import {
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
} from "../../../../pages/Requirement/services/RequirementServices";
import { v4 as uuidv4 } from "uuid";
import AlertModal from "../../../../pages/Requirement/components/common/AlerModel";

const ProductCategory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialFilter =
    location.state?.selectedFilter || "productcategory";
  const [activeUser, setActiveUser] = useState("");
  const [selectedFilter, setSelectedFilter] = useState(initialFilter);
  const { setLoading } = useLoading();
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [productcategory, setProductCategory] = useState([]);
  const [INRToUsd, setINRToUSD] = useState(0.012);
  const [showForm, setShowForm] = useState(false);

  const [searchValues, setSearchValues] = useState({
    searchCategory: "",
  });
  const [productList, setProductList] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editProductCategoryID, setEditProductCategoryID] =
    useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const formRef = useRef(null);

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  // Form state
  const [formData, setFormData] = useState({
    categoryName: "",
  });

  // State for errors
  const [errors, setErrors] = useState({});


  // Handle input change for the form
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    // Check required fields
    if (!formData.categoryName) newErrors.categoryName = "This field is required";
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Simulate API call to save form data
  const saveFormData = async (data) => {
    setLoading(true);
    try {
      // Simulate API call with a 1-second delay
      let body = null;
      console.log("Saving data to API:", data);
      if (isEditMode) {
        body = {
          target: "updateProductCategory",
          productCategoryInput: {
            ProductCategoryID: data.ProductCategoryID,
            CategoryName: data.categoryName,
          },
        };
      } else {
        body = {
          target: "createProductCategory",
          productCategoryInput: {
            ProductCategoryID: data.ProductCategoryID,
            CategoryName: data.categoryName,
          },
        };
      }

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Product category ${
              isEditMode ? "updated" : "added"
            } successfully!`,
            autoClose: 2000,
          });
        }
      }

      // Refresh the table data
      await searchProductCategory(searchValues, rowStart);
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Failed to ${
          isEditMode ? "update" : "add"
        } product category.`,
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const dataToSave = {
        ...formData,
        ProductCategoryID: isEditMode
          ? editProductCategoryID
          : uuidv4(),
      };
      await saveFormData(dataToSave);
      setShowForm(false);
      setIsEditMode(false);
      setEditProductCategoryID(null);
      setSelectedRow(null);
      setFormData({
        categoryName: "",
      });
    } else {
      console.log("Validation failed");
    }
  };

  // Handle form reset
  const handleReset = () => {
    setFormData({
      categoryName: "",
      
    });
    setErrors({});
    setIsEditMode(false);
    setEditProductCategoryID(null);
    setSelectedRow(null);
    setShowForm(false);
  };

  const handleDataFilterChange = useCallback(
    (event) => {
      const selectedValue = event.target.value;
      setSelectedFilter(selectedValue);
      console.log("Selected filter:", selectedValue);
      if (
        selectedValue === "products" ||
        selectedValue === "offers" ||
        selectedValue === "entities"
      ) {
        navigate("/amtpl", { state: { selectedFilter: selectedValue } });
      } else if (selectedValue === "Add Requirement") {
        navigate("/amtpl/addrequirement", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Requirement Approval") {
        navigate("/amtpl/requirement", {
          state: { selectedValue },
        });
      } else if (selectedValue === "Product Offers") {
        navigate("/amtpl/productofferscharges", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Inland Shipping") {
        navigate("/amtpl/inlandshipping", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Country wise Product") {
        navigate("/amtpl/counrywiseproduct", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Product Category") {
        navigate("/amtpl/productcategory", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Product") {
        navigate("/amtpl/product", {
          state: { selectedFilter: selectedValue },
        });
      }
    },
    [navigate]
  );

  const searchProductCategory = useCallback(
    async (searchValue, newRowStart = rowStart) => {
      setLoading(true);

      const body = {
        target: "listProductCategory",
        userOrder: "CategoryName",
        rowStart: newRowStart,
        pageSize: pageSize,
        filterTerms: {
          CategoryNamePartial: searchValue.searchCategory || "",
        },
      };

      try {
        const response = await fetchData(body);
        setProductCategory(response.items || response);
        setTotalItems(response.total || 0);
      } catch (error) {
        console.error("Error loading listProductCategory: ", error);
        setProductCategory([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [rowStart]
  );

  const handleSearch = (searchTerm) => {
    console.log("Searching for:", searchTerm);
    searchProductCategory(searchTerm);
    setRowStart(0);
  };

  const handleRowClick = useCallback(async (row) => {
    console.log("selected row::", row);
    setSelectedRow(row);
    setIsEditMode(true);
    setEditProductCategoryID(row.ProductCategoryID);
    setShowForm(true);
  }, []);

  // Populate form data when selectedRow changes
  useEffect(() => {
    if (selectedRow && isEditMode) {
      setFormData({
        categoryName: selectedRow.CategoryName || "",
        
      });
    }
  }, [selectedRow, isEditMode]);

  // Scroll to form when showForm is true
  useEffect(() => {
    if (showForm && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [showForm]);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut();
          navigate("/");
        } else {
          setActiveUser(user.attributes.email);
        }
        let inrToUsdVal = await getParameterFromManager("INR_TO_USD");
        inrToUsdVal = parseFloat(inrToUsdVal);
        setINRToUSD(inrToUsdVal);
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
  }, [navigate]);

  useEffect(() => {
    searchProductCategory(searchValues);
  }, []);

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    searchProductCategory(searchValues, newRowStart);
  };

  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const fields = [
    {
      name: "searchCategory",
      label: "Search Category",
      type: "text",
      value: searchValues.searchCategory,
      onChange: (value) => setSearchValues((prev) => ({ ...prev, searchCategory: value }))
    },
  ];

  const columns = [
    {
      id: "CategoryName",
      numeric: false,
      label: "Category Name",
      
    },
    
  ];

  return (
    <div className="amtpl-dashboard">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <Header activeUser={activeUser} setLoading={setLoading} />

      <div className="content">
        <SidebarCommon
          selectedFilter={selectedFilter}
          handleDataFilterChange={handleDataFilterChange}
        />
        <main className="main-content">
          <div className="table-header">
            <div className="header-text">
              <div className="head-text">Product Category</div>
              
            </div>
            <div
              className="head-btn"
              style={{ display: "flex", gap: "10px", alignItems: "center" }}
            >
              <div
                className="submit-btn"
                onClick={() => {
                  setShowForm(!showForm);
                  setIsEditMode(false);
                  setFormData({
                    categoryName: "",
                  });
                }}
              >
                Add
              </div>
            </div>
          </div>
          <div className="search-filter">
            <div className="row">
              <SearchFilter fields={fields} onSearch={handleSearch} />
            </div>
          </div>
          <div className="table-css">
            <DataTable
              columns={columns}
              data={productcategory}
              total={totalItems}
              title="Product Category Information"
              rowsPerPage={pageSize}
              onRowClick={handleRowClick}
              onPageChange={handlePageChange}
              currentPage={currentPage}
            />
          </div>
          <div className="table-header">
            <div className="header-text">
              <div className="head-text">
                {/* {isEditMode ? "Edit" : "Add"} */}
              </div>
            </div>
            <div className="head-btn">
              {showForm && (
                <>
                  <div onClick={handleSubmit} className="submit-btn">
                    {isEditMode ? "Update" : "Submit"}
                  </div>
                  <div onClick={handleReset} className="submit-btn">
                    {isEditMode ? "Cancel" : "Reset"}
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Form Section */}
          {showForm && (
            <form
              ref={formRef}
              onSubmit={handleSubmit}
              style={{
                padding: "10px",
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
              }}
            >
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <Typography variant="body2">
                      Category Name
                    </Typography>
                    <TextField
                      type="text"
                      name="categoryName"
                      value={formData.categoryName}
                      onChange={handleChange}
                      sx={{ backgroundColor: "white", width: "100%" }}
                      error={!!errors.categoryName}
                      helperText={errors.categoryName}
                    />
                  </div>
                </div>

              </div>
            </form>
          )}
        </main>
      </div>
    </div>
  );
};

export default ProductCategory;
